import { z } from 'zod'

export type DashboardDataType = {
  alertsCount: number
  residencesCount: number
  residencesMonitoredCount: number
  residenceAlertsCount: number
  communitiesCount: number
  communityAlertsCount: number
  citizensCount: number
  citizensWithResidence: number
  interruptedAlertsCount: number
  inventoriesCount: number
}

export const dashboardObject = {
  alertsCount: z.number(),
  residencesCount: z.number(),
  residencesMonitoredCount: z.number(),
  residenceAlertsCount: z.number(),
  communitiesCount: z.number(),
  communityAlertsCount: z.number(),
  citizensCount: z.number(),
  citizensWithResidence: z.number(),
  interruptedAlertsCount: z.number(),
  inventoriesCount: z.number(),
}
